export interface RutaModyoConfig {
  path: string;
  uidTipo: string;
  slug: string;
  componenteAngular?: string;
}

export interface MapaRutasModyo {
  rutas: RutaModyoConfig[];
}

export const CONFIGURACION_RUTAS_MODYO = {
  UID_TIPO_CONFIGURACION: 'configuracion_rutas',
  SLUG_MAPA_RUTAS: 'mapa-rutas',
} as const;
